import { produce } from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "..";
import {
  CLEAR_ANALYTICS_STATE,
  FETCH_ANALYTICS_LIST_FAILED,
  FETCH_ANALYTICS_LIST_PROGRESS,
  FETCH_ANALYTICS_LIST_SUCCESS,
  FETCH_ANNUAL_PURCHASE_ANALYTICS_FAILED,
  FETCH_ANNUAL_PURCHASE_ANALYTICS_PROGRESS,
  FETCH_ANNUAL_PURCHASE_ANALYTICS_SUCCESS,
  FETCH_ANNUAL_SALES_ANALYTICS_FAILED,
  FETCH_ANNUAL_SALES_ANALYTICS_PROGRESS,
  FETCH_ANNUAL_SALES_ANALYTICS_SUCCESS,
  FETCH_STATE_WISE_SALES_ANALYTICS_FAILED,
  FETCH_STATE_WISE_SALES_ANALYTICS_PROGRESS,
  FETCH_STATE_WISE_SALES_ANALYTICS_SUCCESS,
  FETCH_EXPENSE_MODULE_ANALYTICS_FAILED,
  FETCH_EXPENSE_MODULE_ANALYTICS_PROGRESS,
  FETCH_EXPENSE_MODULE_ANALYTICS_SUCCESS,
} from "./analyticsActions";
import { defaultAnalyticsState } from "./defaultState";
import { AnalyticsAcions } from ".";

export const analyticsReducer = (
  state: IStoreState["analytics"] = defaultAnalyticsState,
  action: AnalyticsAcions,
) => {
  switch (action.type) {
    case FETCH_ANALYTICS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.analytics.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_ANALYTICS_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.analytics.loading = LoadState.Loaded;
        draftState.analytics.data = data;
        draftState.analytics.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_ANALYTICS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.analytics.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_ANNUAL_SALES_ANALYTICS_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.salesData.loading = LoadState.InProgress;
      });
    }
    case FETCH_ANNUAL_SALES_ANALYTICS_SUCCESS: {
      const { data, totalRecords } = action.payload;
      return produce(state, (draftState) => {
        draftState.salesData.loading = LoadState.Loaded;
        draftState.salesData.data = data;
        draftState.salesData.totalRecords = totalRecords;
      });
    }

    case FETCH_ANNUAL_SALES_ANALYTICS_FAILED: {
      return produce(state, (draftState) => {
        draftState.salesData.loading = LoadState.Failed;
        draftState.salesData.error = "Failed to load annual sales analytics";
      });
    }

    case FETCH_ANNUAL_PURCHASE_ANALYTICS_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.purchaseData.loading = LoadState.InProgress;
      });
    }
    case FETCH_ANNUAL_PURCHASE_ANALYTICS_SUCCESS: {
      const { data, totalRecords } = action.payload;
      return produce(state, (draftState) => {
        draftState.purchaseData.loading = LoadState.Loaded;
        draftState.purchaseData.data = data;
        draftState.purchaseData.totalRecords = totalRecords;
      });
    }

    case FETCH_ANNUAL_PURCHASE_ANALYTICS_FAILED: {
      return produce(state, (draftState) => {
        draftState.purchaseData.loading = LoadState.Failed;
        draftState.purchaseData.error =
          "Failed to load annual purchase analytics";
      });
    }

    case FETCH_STATE_WISE_SALES_ANALYTICS_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.stateWiseSalesData.loading = LoadState.InProgress;
      });
    }
    case FETCH_STATE_WISE_SALES_ANALYTICS_SUCCESS: {
      const { data, totalRecords } = action.payload;
      return produce(state, (draftState) => {
        draftState.stateWiseSalesData.loading = LoadState.Loaded;
        draftState.stateWiseSalesData.data = data;
        draftState.stateWiseSalesData.totalRecords = totalRecords;
      });
    }
    case FETCH_STATE_WISE_SALES_ANALYTICS_FAILED: {
      return produce(state, (draftState) => {
        draftState.stateWiseSalesData.loading = LoadState.Failed;
        draftState.stateWiseSalesData.error =
          "Failed to load state-wise sales analytics";
      });
    }

    case FETCH_EXPENSE_MODULE_ANALYTICS_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.expenseModuleAnalytics.loading = LoadState.InProgress;
      });
    }
    case FETCH_EXPENSE_MODULE_ANALYTICS_SUCCESS: {
      const { data, totalRecords } = action.payload;
      return produce(state, (draftState) => {
        draftState.expenseModuleAnalytics.loading = LoadState.Loaded;
        draftState.expenseModuleAnalytics.data = data;
        draftState.expenseModuleAnalytics.totalRecords = totalRecords;
      });
    }
    case FETCH_EXPENSE_MODULE_ANALYTICS_FAILED: {
      return produce(state, (draftState) => {
        draftState.expenseModuleAnalytics.loading = LoadState.Failed;
        draftState.expenseModuleAnalytics.error =
          "Failed to load expense module analytics";
      });
    }

    case CLEAR_ANALYTICS_STATE: {
      return defaultAnalyticsState;
    }
    default: {
      return state;
    }
  }
};
